import {QuestionLink} from '@dfl/react-auth-module';
import {Typography} from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {memo} from 'react';
import {useTranslation} from 'react-i18next';

import {ReactComponent as BoxLines} from '@/assets/images/security-lines.svg';
import { useSettings } from '@/modules/configuration/hooks/useSettings';

import style from './index.less';
// import { useAuthDropdown } from '@/contexts/AuthDropdownContext';

const {Text} = Typography;

const questionLink = {
  link: '/proposal',
  linkText: 'signup.title',
  question: 'login.needAccount',
};

const AuthLayoutRight = ({setVisible}) => {
  const { data: configurations } = useSettings();
  const {t} = useTranslation('authentication');

  return (
    <div className={classNames('hidden lg:flex relative p-6 flex-col justify-center min-h-full w-96 auth-right-side')}>
      <div className={classNames(style.backgroundLines, 'absolute w-full z-10')}>
        <BoxLines/>
      </div>
      <div className="z-20">
        <div>
          <div className="md:mb-4 text-center md:text-left">
            <Text className="text-2xl md:text-3xl text-white">{t('login.title')}</Text>
          </div>
          <div className="mb-4 hidden md:block">
            <Text className="text-white">
              {t('login.subtext')}
            </Text>
          </div>
        </div>
        <div className={classNames('text-white', { hidden: configurations?.inMaintenance })}>
          <QuestionLink
            onClick={() => setVisible(false)}
            link={questionLink.link}
            linkClassNames={'text-white hover:underline'}
            linkText={t(questionLink.linkText)}
            question={t(questionLink.question)}/>
        </div>
      </div>
    </div>
  );
};

AuthLayoutRight.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  setVisible: PropTypes.func,
};

AuthLayoutRight.defaultProps = {};

export default memo(AuthLayoutRight);
